module.exports = "/success-598f5ad8132bf3cde04881f65dd95408.svg";